<script lang="ts">
    import ConfigCheckbox from "../../../ui-elements/utils/ConfigCheckbox.svelte";
    import {guiCreatorDataStore} from '../../../stores/guiCreatorData';
    import {GUICreatorData} from '../../../stores/types';

    export let showWidgetBarTop = false;
    export let onShowWidgetBarTopChange;

    let swipeableValue = false;
    guiCreatorDataStore.subscribe((data: GUICreatorData) => {
        swipeableValue = data.pages[data.currentPage]?.swipeable;
    });


    function updateSwipeable(newSwipeableValue) {
        guiCreatorDataStore.updateSwipeable(guiCreatorDataStore.get().currentPage, newSwipeableValue.detail);
    }

    function onShowWidgetTopBarChange(newValue) {
        onShowWidgetBarTopChange(newValue.detail)
    }
</script>

<div class="uiListItem config-item border border-accent pb-1.5 pt-1.5">
    <ConfigCheckbox value="{swipeableValue}" on:configValueChanged={updateSwipeable}
                    title="Page swipeable"></ConfigCheckbox>
    <ConfigCheckbox value="{showWidgetBarTop}" on:configValueChanged={onShowWidgetTopBarChange}
                    title="Show top widget bar"></ConfigCheckbox>
</div>

<style>

    .config-item {
        width: 100%;
    }

</style>
